const PREFIX = "repman-admin-prefs-v1";

function storageKey(suffix) {
  return `${PREFIX}:${suffix}`;
}

function readJson(key, fallback) {
  if (typeof window === "undefined") return fallback;
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

function writeJson(key, value) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(key, JSON.stringify(value));
}

const DEFAULT_ALERTS = {
  newDeletionCase: true,
  newUserRegistration: true,
  criticalReviewFlagged: true,
  caseStatusChange: true,
  weeklyPlatformDigest: false,
};

const DEFAULT_SETTINGS = {
  language: "de",
  timezone: "Europe/Berlin",
  compactTables: false,
  emailNotifications: true,
  showCasePricing: true,
  confirmImpersonation: true,
};

export function loadAdminEmailAlertPrefs() {
  return { ...DEFAULT_ALERTS, ...readJson(storageKey("email-alerts"), {}) };
}

export function saveAdminEmailAlertPrefs(prefs) {
  writeJson(storageKey("email-alerts"), prefs);
}

export function loadAdminSettings() {
  return { ...DEFAULT_SETTINGS, ...readJson(storageKey("settings"), {}) };
}

export function saveAdminSettings(settings) {
  writeJson(storageKey("settings"), settings);
}
